import { ProductType } from 'marketplace-ui-common/types/products';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import {
  InstallButtonClicked,
  MarketplaceInteraction,
  getInstallButtonClickedEvent,
  getMarketplaceInteractionEvent,
  getPageViewedEvent,
} from 'marketplace-ui-tracking/events/marketplace';

export const SCREEN = 'listing details';
export const REVIEW_SCREEN = 'listing details review';

interface useTrackingProps {
  appContext: string;
  companyName?: string;
  embed: boolean;
  installed?: boolean;
  isPreview?: boolean;
  isReviewLink?: boolean;
  listingId: number;
  slug: string;
  sourceId: string;
  type: ProductType;
}

export const useTracking = ({
  appContext,
  companyName,
  embed,
  installed,
  isPreview,
  isReviewLink,
  listingId,
  slug,
  sourceId,
  type,
}: useTrackingProps) => {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();

  const trackInteraction = (eventProps: MarketplaceInteraction) => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(
      getMarketplaceInteractionEvent({
        companyName,
        embed,
        inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
        installed,
        listingId,
        screen: isReviewLink ? REVIEW_SCREEN : SCREEN,
        slug,
        sourceId: [sourceId],
        type,
        ...eventProps,
      })
    );
  };

  const trackInstall = (eventProps: Partial<InstallButtonClicked>) => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(
      getInstallButtonClickedEvent({
        companyName,
        embed,
        inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
        listingId,
        screen: isReviewLink ? REVIEW_SCREEN : SCREEN,
        slug,
        sourceId: [sourceId],
        type,
        ...eventProps,
      })
    );
  };

  const trackPageViewed = () => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(
      getPageViewedEvent({
        companyName,
        embed,
        inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
        installed,
        screen: isReviewLink ? REVIEW_SCREEN : SCREEN,
        sourceId: [`${type}__${sourceId}`],
        slug,
        type,
      })
    );
  };

  return {
    trackInstall,
    trackInteraction,
    trackPageViewed,
  };
};
